import { getAccessToken } from '@/utils/auth'

const statusEnum = { 'ok': 1, 'unauthorised': 2, 'error': 3, 'notFound': 4 }

function handleAxiosPromise (p) {
  return p
    .then(response => { return { 'status': statusEnum.ok, 'response': response.data } })
    .catch(r => {
      if (r && r.response && (r.response.status === 401 || r.response.status === 404)) {
        const s = r.response.status === 401 ? statusEnum.unauthorised : statusEnum.notFound
        return { 'status': s, 'response': '' }
      } else {
        return { 'status': statusEnum.error, 'response': '' }
      }
    })
}

function apiConfig () {
  return { headers: { Authorization: `Bearer ${getAccessToken()}` } }
}

export { statusEnum, handleAxiosPromise, apiConfig }



// WEBPACK FOOTER //
// ./src/utils/api-common.js